import '../translations'
import * as React from 'react'
import * as Sentry from '@sentry/react'
import App from '../containers/Accountant/App'
import { Provider } from 'react-redux'
import store from '../store'
import { Toaster } from '../components/ui/sonner'
import '../styles/tailwind.css'
import { SENTRY_DSN } from '../Constants'
import i18n from '../translations'
import { AccountantCurrentUser } from '../types'

Sentry.init({ dsn: SENTRY_DSN })

interface IProps {
    currentUser?: AccountantCurrentUser
}

const stateAccountant: AccountantCurrentUser | undefined = window['__STATE__']?.authentication?.currentAccountant

// Set before first render so the UI never flashes the default language
i18n.changeLanguage(stateAccountant?.locale || 'en')

export default class Application extends React.Component<IProps> {
    render() {
        return (
            <Provider store={store}>
                <App />
                <Toaster position="bottom-center" />
            </Provider>
        )
    }
}